import React from 'react'
import HomeBanner from '../Components/Home/HomeBanner'
import HomeCompanies from '../Components/Home/HomeCompanies'
import HomeWork from '../Components/Home/HomeWork'
import HomeServices from '../Components/Home/HomeServices'
import HomeStatics from '../Components/Home/HomeStatics'
import HomeProjects from '../Components/Home/HomeProjects'
import HomeWhyUs from '../Components/Home/HomeWhyUs'
// import HomeJobs from '../Components/Home/HomeJobs'
// import HomePricing from '../Components/Home/HomePricing'
import HomeTestimonial from '../Components/Home/HomeTestimonial'

function Home() {
  return (
    <>
      <HomeBanner />
      <HomeCompanies />
      <HomeWork />
      <HomeServices />
      <HomeStatics />
      <HomeProjects />
      <HomeWhyUs />
      {/* <HomeJobs /> */}
      {/* <HomePricing /> */}
      <HomeTestimonial />

    </>
  )
}

export default Home
